import type { Locale as AntdLocale } from 'antd/es/locale';
import antdLocaleEN from 'antd/locale/en_GB';
import antdLocaleIT from 'antd/locale/it_IT';
import 'dayjs/locale/en';
import 'dayjs/locale/it';
import { GenLanguageTag } from './types/GenCountryCode';

// Reference https://www.w3schools.com/tags/ref_language_codes.asp
const languages = ['it', 'en'] as const;
export type LanguageCode = (typeof languages)[number];

const languageCountries = {
  it: ['IT'],
  en: ['GB'],
} as const satisfies Record<LanguageCode, string[]>;
export type LanguageTag = GenLanguageTag<typeof languageCountries>;

export interface Locale {
  tag: LanguageTag;
  language: LanguageCode;
  label: string;
  name: string;
  nativeName?: string;
  i18nLocale: LanguageCode;
  antdLocale: AntdLocale;
  dayjsLocale: `${string}-${string}`;
}

const defaultLocale = {
  tag: 'it-IT',
  language: 'it',
  label: 'IT',
  name: 'Italiano',
  i18nLocale: 'it',
  antdLocale: antdLocaleIT,
  dayjsLocale: 'it-IT',
} as const satisfies Locale;

const locales = {
  'it-IT': defaultLocale,
  'en-GB': {
    tag: 'en-GB',
    language: 'en',
    label: 'EN',
    name: 'Inglese',
    nativeName: 'English',
    i18nLocale: 'en',
    antdLocale: antdLocaleEN,
    dayjsLocale: 'en-GB',
  },
} as const satisfies Record<LanguageTag, Locale>;

export { defaultLocale, languageCountries, languages, locales };
